import React, { Component } from 'react';
import PropTypes from 'prop-types';


//import classNames from 'classnames';
import pages from '../../app/services';
import { Box, styled, type Theme } from '@mui/material';
import Header from './Header';
import LeftDrawer from './LeftDrawer';

const drawerWidth = 240;
const miniDrawerWidth = 60;

const s:any = {
  hide: {
    display: 'none',
  },
  content: {
    marginLeft:0,
    flexGrow: 1,
    backgroundColor: 'background.default',
    p: 1,
  },
  toolbar: (theme:Theme)=>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }),
  
  contentShift: (theme:Theme)=>({
    [theme.breakpoints.down('sm')]:{
      width: `calc(100% - ${miniDrawerWidth}px)`,
      marginLeft: `${miniDrawerWidth}px`,
    },
    marginLeft: `${drawerWidth}px`,

    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),

  body: {
    m: 1,
  }
};

const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);

class Content extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      page: props.page,
      count:0,
      params: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps:any) {
    if (
      this.props.page !== nextProps.page ||
      this.props.page === "search" ||
      this.props.page === "kanban"
    ) {
      this.setState({page: nextProps.page});
    }
    //else this.setState({page: nextProps.page});
  }

  getPrivs = () => {
    const {page,userData} = this.props;
    const { pv } = userData;
    const pvs = pv.filter((v:any)=>v.acf===page);
    //console.log('pvs:'.pvs);
    return pvs;
  };

  getActions = (file:any) => (sts:any) => {
    const pvs = this.getPrivs();
    //const pvset:any = {};
    const pvlist = pvs.reduce((acc:any,c:any)=>{
      //if(sts === 0 && !['add','view'][c.bfn]) return acc;
      if(c.sts===1) {
        acc.push(c.bfn);
        //pvset[c.bfn] = c.btx;
      }
      return acc;
    },[]);
    //console.log('file:',file,',sts:',sts,'pva:',pva);
    return pvlist; //{pvlist,pvset};
  };

  getPrivActions = () => {
    const pvs = this.getPrivs();
    const pvset:any = {};
    const pvlist = pvs.reduce((acc:any[], c:any) => {
      if (c.sts === 1) {
        acc.push(c.bfn);
        pvset[c.bfn] = c.btx;
      }
      return acc;
    }, []);
    return { pvlist, pvset };
  };

  setPage = (page:any) => this.setState({page:page});

  setHome = () => this.setState({ page: "dashboard" });

  //For params, use Functional State to void shallow merge overwrite bug
  setParam = (k:string,v:any) => this.setState((p:any)=>({...p, params:{...p.params,[k]:v} }));

  unsetParam = (k: string) => this.setState((p: any) => ({...p, params: { ...p.params,[k]:null } }));

  resetParams = () => this.setState({params:{}});

  onParam = (action:string) => (k:string,v:any) => {
    if(action==='set') this.setParam(k,v);
    else if(action==='unset') this.unsetParam(k);
    else if(action==='reset') this.resetParams();
    else return;
  };

  render() {
    const {userData,code,navDrawerOpen,showNotification,handleSetContent,cstyles,title,...others} = this.props;
    //const { search, query, startSearch, stopSearch, searchres, searchmeta } = this.props;
    const { search, query, startSearch, stopSearch, searchres, searchmeta, ...extras } = others;
    const {page,params} = this.state;
    //    const { plancontext,planningContextLoading,planningContextSwitching} = this.props;

    //const {page} = this.state;
    //const {children} = this.props;
    //console.log('page',page);
    const {pvlist,pvset} = this.getPrivActions();
    return (
      // <Box
      //   sx={{
      //     display: "flex",
      //     flexDirection: "column",
      //     minHeight: "100vh",
      //     bgcolor: "#F6F8F9",
      //   }}
      // >

      //   <Header />

      //   <Box sx={{ display: "flex", flex: 1 }}>

      //     <LeftDrawer />

      //     <Box
      //       sx={{
      //         flex: 1,
      //         p: 3,
      //         pt: 10, // account for header
      //       }}
      //     >
      //       {children}
      //     </Box>

      //   </Box>
      // </Box>
      <Box component='main' sx={{...s.content, ...(navDrawerOpen? s.contentShift: {})}}>
        {/* <Box sx={{...s.toolbar}} /> */}
        <Offset />
        <Box style={cstyles}>
          {React.cloneElement(
            (page in pages)?pages[page]:pages.main,
            {
              title: title||page,
              //page:page,
              service: page,
              search: search,
              searchres: searchres,
              searchmeta: searchmeta,
              query: query,
              params: params,
              rowActions: this.getActions(page), //pvlist, //
              actionSet: pvset,
              setHome: this.setHome,
              setPage: this.setPage,
              onParam: this.onParam,
              startSearch: startSearch,
              stopSearch: stopSearch,
              showNotification: showNotification, 
              handleSetContent: handleSetContent,
              merchantCode: this.props.merchantCode, 
              code: code,
              userData: userData,
              ...extras,
            }
          )}
        </Box>
      </Box>
    );
  }
}

Content.propTypes = {
  styles: PropTypes.object,
  showNotification: PropTypes.func,
  page: PropTypes.string
};

export default Content;
